import { render, staticRenderFns } from "./uploadoss.vue?vue&type=template&id=f47a607c&"
import script from "./uploadoss.vue?vue&type=script&lang=js&"
export * from "./uploadoss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports